{
  "decrease": "Decrease {fieldLabel}",
  "increase": "Increase {fieldLabel}",
  "numberField": "Number field"
}
